import z from "zod";

export const schema = z.object({
	email: z.email("Invalid email address"),
});

export type Schema = z.infer<typeof schema>;
